export default __webpack_public_path__ + "b3c6e9a748ef6994aabce66eea03c395.webp";